export function formatDateTime(date: Date) {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const ms = m < 10 ? ('0' + m) : m;
    const d = date.getDate();
    const ds = d < 10 ? ('0' + d) : d;
    const h = date.getHours();
    const minute = date.getMinutes();
    const minutes = minute < 10 ? ('0' + minute) : minute;
    const second = date.getSeconds();
    const seconds = second < 10 ? ('0' + second) : second;
    return y + '-' + ms + '-' + ds + ' ' + h + ':' + minutes + ':' + seconds;
}

export function formatDate(date: Date) {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const ms = m < 10 ? ('0' + m) : m;
    const d = date.getDate();
    const ds = d < 10 ? ('0' + d) : d;
    return y + '-' + ms + '-' + ds;
}
export function formatHour(date: Date) {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const ms = m < 10 ? ('0' + m) : m;
    const d = date.getDate();
    const ds = d < 10 ? ('0' + d) : d;
    const h = date.getHours();
    const minute = date.getMinutes();
    const minutes = minute < 10 ? ('0' + minute) : minute;
    const second = date.getSeconds();
    const seconds = second < 10 ? ('0' + second) : second;
    return h + ':' + minutes;
}

export function formatYear(date: Date) {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const ms = m < 10 ? ('0' + m) : m;
    const d = date.getDate();
    const ds = d < 10 ? ('0' + d) : d;
    return y + '';
}

export function formatMonth(date: Date) {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const ms = m < 10 ? ('0' + m) : m;
    const d = date.getDate();
    const ds = d < 10 ? ('0' + d) : d;
    return y + '-' + ms;
}